import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
// import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { FieldDetails } from '../../models/global/FieldDetails';
import { SwalService } from '../../services/swal.service';
import { FieldTypes } from '../../models/global/FieldTypes';
import { CustomValidator } from '../../../helpers/custom.validator';
import { DatePipe } from '@angular/common';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';

export interface DialogData {
  title: string;
  titleField: string;
  comment: string;
  record: any;
  serviceTarget: string;
  service: any;
  showClose: boolean;
  showBack: boolean;
  hideSwalMessageSuccess: boolean;
  showDefaultSwal: boolean;
  btnSubmitTitle: string;
  btnSubmitClass: string;
  swalMessageSuccess: string;
  commentProperty: string;
  helpersTop: {
    label: string;
    class: string;
  }[];
  helpersMiddle: {
    label: string;
    class: string;
  }[];
  helpersbottom: {
    label: string;
    class: string;
  }[];
  fields: FieldDetails[];
  isFormData: boolean;
}

@Component({
  selector: 'app-dynamic-form',
  standalone: false,
  templateUrl: './dynamic-form.component.html'
})
export class DynamicFormComponent implements OnInit {
  formGroup: FormGroup = new FormGroup({});
  loading = false;
  isSubmitted = false;
  fields: FieldDetails[] = [];
  fieldTypes = FieldTypes

  // SearchCountryField = SearchCountryField;
  // CountryISO = CountryISO;
  // PhoneNumberFormat = PhoneNumberFormat;
  // selectedCountryISO: string = CountryISO.SaudiArabia;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<DynamicFormComponent>,
    private readonly translate: TranslateService,
    private datePipe: DatePipe,
    private readonly swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    let ctr = null;
    if (this.data && this.data.fields && this.data.fields.length) {
      this.fields = this.data.fields;
    } else {
      this.fields.push({
        id: this.data.commentProperty ? this.data.commentProperty : 'comment',
        value: this.data.comment,
        isMandatory: true,
        inputTypeId: FieldTypes.TEXTAREA,
        inputTitle: this.data.titleField,
        fieldLength: 500
      } as any)
    }
    if (this.fields.length) {
      this.fields.forEach(field => {
        if (field.inputTypeId !== FieldTypes.FILE) {
          let inputAnswer = field.value;
          ctr = new FormControl(inputAnswer || null);
          ctr.setValidators(this.setValidation(field, true));
          this.formGroup.addControl(String(field.id), ctr);
        }
      });
    }
  }

  setValidation(field: FieldDetails, setValidation: any) {
    const validations = [];
    if (field.inputTypeId === FieldTypes.NUMBER && field.isMandatory) {
      validations.push(Validators.pattern(Patterns.number));
      if (field.jsonProps.hasARange) {
        validations.push(Validators.min(field.jsonProps.minimumRange));
        validations.push(Validators.max(field.jsonProps.maxRange));
      }
    }
    if (field.inputTypeId === FieldTypes.TEXTAREA && field.isMandatory) {
      validations.push(CustomValidator.noWhiteSpace);
    } else if (field.isMandatory) {
      validations.push(CustomValidator.noWhiteSpace);
    }
    if (field.inputTypeId === FieldTypes.EMAIL) {
      validations.push(Validators.email, Validators.pattern(Patterns.email))
      if (field.isMandatory) {
        validations.push(Validators.required);
      }
    }
    if (field.pattern) {
      validations.push(Validators.pattern(field.pattern));
    }
    return setValidation ? validations : null;
  }

  bindDataToUpdate() {
    if (this.data.comment) {
      this.formGroup.controls['comment'].setValue(this.data.comment);
    }
  }

  hasError(errorName: string, controlName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  formatLocalDate = (value: any): any => {
    if (!value) return null;
    const date = new Date(value);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // YYYY-MM-DD
  };

  saveRecord() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      if (this.data.serviceTarget) {
        let record: any = {};
        let data = null;
        const formData = new FormData();
        this.fields.forEach((field: any, index: number) => {
          if (field.inputTypeId == FieldTypes.Tel) {
            record[field.id] = this.formGroup.controls[field.id].value.internationalNumber;
          } else if (field.inputTypeId == FieldTypes.DATE && (this.fields.some((obj: any) => obj.inputTypeId === FieldTypes.FILE) || this.data.isFormData)) {
            record[field.id] = this.formatLocalDate(this.formGroup.controls[field.id].value)
          } else if (field.inputTypeId !== FieldTypes.FILE) {
            record[field.id] = this.formGroup.controls[field.id].value;
          } else {
            if (field && field.value && field.value.length) {
              (field.value as any[]).forEach(file => {
                if (!file.id) {
                  formData.append(field.id, file, file.name);
                }
              });
            }
            record[field.deletedKey] = field.deletedAttachments;
          }
        });
        if (this.data.record) {
          record = { ...this.data.record, ...record };
          data = record;
        } else {
          data = record;
        }
        if (this.fields.some((obj: any) => obj.inputTypeId === FieldTypes.FILE) || this.data.isFormData) {
          formData.append('data', JSON.stringify(record));
          data = formData
        }
        const service = this.data.service;
        service[this.data.serviceTarget](data).subscribe(() => {
          this.loading = false;
          if (!this.data.hideSwalMessageSuccess && !this.data.showDefaultSwal) {
            // this.swalService.swalSuccess(this.data.swalMessageSuccess ? this.data.swalMessageSuccess : this.translate.instant('swalMsg.savedsuccessfully'))
            Swal.fire({
              title: this.data.swalMessageSuccess ? this.data.swalMessageSuccess : this.translate.instant('swalMsg.savedsuccessfully'),
              imageUrl: './assets/images/icons/success.svg',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          }
          if (this.data.showDefaultSwal) {
            Swal.fire({
              title: this.data.swalMessageSuccess ? this.data.swalMessageSuccess : this.translate.instant('swalMsg.savedsuccessfully'),
              imageUrl: './assets/images/icons/success.svg',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });

          }
          this.dialogRef.close(this.formGroup.value);
        }, (err: any) => {
          this.loading = false;
          const errors = JSON.parse(err.detail);
          let message = '';
          if (err.detail) {
            errors.ErrorDTO.forEach((error: any) => {
              if (error.ErrorCode === 'Repeated') {
                this.formGroup.controls[error.ErrorDetail].setErrors({ notUniqe: true });
              } else {
                message = error.Error;
              }
            });
          } else {
            message = err.title;
          }
          if (message) {
            this.swalService.swalFailed(message);
          }
        });
      } else {
        setTimeout(() => {
          this.loading = false;
          this.dialogRef.close(this.formGroup.value);
        }, 1000);
      }

    }
  }

  backDialog() {
    this.dialogRef.close({ back: true });
  }

  changeVlaue(e: any) {
    this.formGroup.controls['comment'].setValue(null);
  }

}
